/* eslint-disable */
import { Badge, Button, Input } from 'antd'
import React, { useEffect, useState, useRef } from 'react'
import { usePlacesWidget } from 'react-google-autocomplete'
import { useTranslation } from 'react-i18next'
import { GoSearch } from 'react-icons/go'
import {
  experienceOptionsFilters,
  remoteOptions,
  schoolLevelOptions,
} from '../../utils'
import CustomSelect from './CustomSelect'
import * as s from './styles'
import { AiOutlineDelete } from 'react-icons/ai'

const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY

const Filters = ({
  onFilter,
  contractTypes,
  activeFilters,
  jobsDomain,
  subJobs,
  sectors,
  subSectors,
  setHasFilters,
  hasFilters,
  openRespFilters,
  setOpenRespFilters,
}) => {
  const { t } = useTranslation(['careers', 'common', 'campaign'], {
    useSuspense: false,
  })
  const [selectedlocations, setSelectedLocations] = useState([])

  const [selectedContractTypes, setSelectedContractTypes] = useState(
    activeFilters.contractType ? activeFilters.contractType : [],
  )
  const [selectedJobs, setSelectedJobs] = useState(
    activeFilters.jobDomain ? activeFilters.jobDomain : [],
  )
  const [selectedSubJobs, setSelectedSubJobs] = useState(
    activeFilters.subJob ? activeFilters.subJob : [],
  )
  const [selectedSectors, setSelectedSectors] = useState(
    activeFilters.sector ? activeFilters.sector : [],
  )
  const [selectedSubSectors, setSelectedSubSectors] = useState(
    activeFilters.subSector ? activeFilters.subSector : [],
  )
  const [selectedExperience, setSelectedExperience] = useState(
    activeFilters.experience ? activeFilters.experience : [],
  )
  const [selectedSchoolLevel, setSelectedSchoolLevel] = useState(
    activeFilters.schoolLevel ? activeFilters.schoolLevel : [],
  )
  const [selectedRemoteWorking, setSelectedRemoteWorking] = useState(
    activeFilters.remoteWorking ? activeFilters.remoteWorking : [],
  )

  // input for city search
  const [citySearchValue, setCitySearchValue] = useState('')

  // ----- REFS
  const selectRef = useRef()

  const clearAll = () => {
    setHasFilters(false)
    setSelectedLocations([])
    // erase the value of the GoogleAutocomplete component
    setSelectedContractTypes([])
    setSelectedJobs([])
    setSelectedSubJobs([])
    setSelectedSectors([])
    setSelectedSubSectors([])
    setSelectedExperience([])
    setSelectedSchoolLevel([])
    setSelectedRemoteWorking([])
    onFilter({
      location: [],
      contractType: [],
      jobDomain: [],
      subJob: [],
      sector: [],
      subSector: [],
      experience: [],
      schoolLevel: [],
      remoteWorking: [],
    })
    setCitySearchValue('')
  }

  const handleSubmit = () => {
    onFilter({
      ...activeFilters,
      location: selectedlocations.length ? selectedlocations : undefined,
      contractType: selectedContractTypes.length
        ? selectedContractTypes
        : undefined,
      jobDomain: selectedJobs.length ? selectedJobs : undefined,
      subJob: selectedSubJobs.length ? selectedSubJobs : undefined,
      sector: selectedSectors.length ? selectedSectors : undefined,
      subSector: selectedSubSectors.length ? selectedSubSectors : undefined,
      experience: selectedExperience.length ? selectedExperience : undefined,
      schoolLevel: selectedSchoolLevel.length ? selectedSchoolLevel : undefined,
      remoteWorking: selectedRemoteWorking.length
        ? selectedRemoteWorking
        : undefined,
    })
  }

  useEffect(() => {
    if (
      selectedlocations.length ||
      selectedContractTypes.length ||
      selectedJobs.length ||
      selectedSectors.length ||
      selectedSubJobs.length ||
      selectedSubSectors.length ||
      selectedExperience.length ||
      selectedSchoolLevel.length ||
      selectedRemoteWorking.length
    ) {
      setHasFilters(true)
      handleSubmit()
    } else {
      setHasFilters(false)
      handleSubmit()
    }
  }, [
    selectedlocations,
    selectedContractTypes,
    selectedJobs,
    selectedSectors,
    selectedSubJobs,
    selectedSubSectors,
    selectedExperience,
    selectedSchoolLevel,
    selectedRemoteWorking,
  ])

  // antd stuff for google api

  //  /!\ This function has a side effect on the state of the input.
  const { ref: antRef } = usePlacesWidget({
    onPlaceSelected: (place) => {
      // set place.address
      setSelectedLocations([
        ...selectedlocations,
        place.address_components?.[0]?.long_name,
      ])
      // todo : change this dirty fix for adding "france at the end of the address"
      setCitySearchValue(place.address_components?.[0].long_name + ', France')
    },

    options: { types: ['(cities)'], componentRestrictions: { country: 'fr' } },
  })

  return (
    <s.FiltersWrapper>
      <div
        className="flex column select"
        style={{
          overflowAnchor: 'auto',
          padding: '0px',
          height: '100%',
          flexGrow: 1,
          alignItems: 'start',
          gap: 10,
        }}
      >
        <div className="filter-header" style={{ height: '41px' }}>
          <span
            style={{
              fontWeight: '600',
              fontSize: '14px',
              padding: '4px',
            }}
          >
            {t('common:filters')}
          </span>
          {hasFilters && (
            <Button
              className="btn-clear"
              type="text"
              size="small"
              danger
              icon={<AiOutlineDelete />}
              onClick={clearAll}
              tabIndex={-1}
            >
              {t('common:clearAll')}
            </Button>
          )}
        </div>

        {/* Locations */}
        <div className="select">
          <Input
            className="ant-border-radius"
            allowClear
            ref={(c) => {
              if (c) antRef.current = c.input
            }}
            value={citySearchValue}
            size="large"
            onChange={(e) => {
              if (e.target.value === '') {
                setSelectedLocations([])
              }
              // same as in the widget
              setCitySearchValue(e.target.value)
            }}
          />
        </div>

        {/* Jobs */}
        <div className="select">
          <CustomSelect
            className="ant-border-radius"
            ref={selectRef}
            placeholder={t('common:table.jobdomain')}
            list={jobsDomain?.map((job) => ({
              label: job,
              value: job,
            }))}
            action={{
              state: selectedJobs,
              setState: setSelectedJobs,
            }}
            type="checkbox"
            trigger={['click']}
            withSearchBar
          />
        </div>

        {/* Sub-jobs */}
        <div className="select">
          <CustomSelect
            ref={selectRef}
            placeholder={t('common:table.subjobs')}
            list={subJobs?.map((subjob) => ({
              label: subjob,
              value: subjob,
            }))}
            action={{
              state: selectedSubJobs,
              setState: setSelectedSubJobs,
            }}
            type="checkbox"
            trigger={['click']}
            withSearchBar
          />
        </div>

        {/* Sectors */}
        <div className="select">
          <CustomSelect
            placeholder={t('common:table.sectors')}
            list={sectors?.map((sector) => ({
              label: sector,
              value: sector,
            }))}
            action={{
              state: selectedSectors,
              setState: setSelectedSectors,
            }}
            type="checkbox"
            trigger={['click']}
            withSearchBar
          />
        </div>

        {/*  Sub-sectors  */}
        <div className="select">
          <CustomSelect
            ref={selectRef}
            placeholder={t('common:table.subsectors')}
            list={subSectors?.map((subsector) => ({
              label: subsector,
              value: subsector,
            }))}
            action={{
              state: selectedSubSectors,
              setState: setSelectedSubSectors,
            }}
            type="checkbox"
            trigger={['click']}
            withSearchBar
          />
        </div>

        {/*  Experience  */}
        <div className="select">
          <CustomSelect
            ref={selectRef}
            placeholder={t('common:experienceForm.label')}
            list={experienceOptionsFilters(t)}
            action={{
              state: selectedExperience,
              setState: setSelectedExperience,
            }}
            type="checkbox"
            trigger={['click']}
          />
        </div>

        {/*  School level  */}
        <div className="select">
          <CustomSelect
            ref={selectRef}
            placeholder={t('common:table.schoolLevel')}
            list={schoolLevelOptions(t)}
            action={{
              state: selectedSchoolLevel,
              setState: setSelectedSchoolLevel,
            }}
            type="checkbox"
            trigger={['click']}
          />
        </div>

        {/*  Contract type  */}
        <div className="select">
          <CustomSelect
            ref={selectRef}
            placeholder={t('careers:filters.contractType.placeholder')}
            list={contractTypes?.map((contract) => ({
              label: contract,
              value: contract,
            }))}
            action={{
              state: selectedContractTypes,
              setState: setSelectedContractTypes,
            }}
            type="checkbox"
            trigger={['click']}
            withSearchBar
          />
        </div>
        {/*  Remoteworking  */}
        <div className="select">
          <CustomSelect
            ref={selectRef}
            placeholder={t(
              'campaign:createOffer.generalStep.remoteWorking.label',
            )}
            list={remoteOptions(t)}
            action={{
              state: selectedRemoteWorking,
              setState: setSelectedRemoteWorking,
            }}
            type="checkbox"
            trigger={['click']}
            withSearchBar
          />
        </div>
      </div>
    </s.FiltersWrapper>
  )
}

export default Filters
